<a [routerLink]="['/profile']" class="h-48">

    <ng-container *ngIf="hasExternalPhoto; else internalImage">
        <app-image css="rounded-full w-24 h-24 mx-auto" [img]="processedImage || defaultImage" alt="avatar">
        </app-image>
    </ng-container>

    <ng-template #internalImage>
        <app-image css="rounded-full w-24 h-24 mx-auto" [img]="image?.photoPath ? image.photoPath : defaultImage"
            alt="avatar">
        </app-image>
    </ng-template>
    <p class="mb-0 mt-2 text-md text-center text-gray-800 font-bold">
        {{ username }}
    </p>
</a>